import { AuthConfig } from 'angular-oauth2-oidc';
import { AuthConfigModel } from '../models/auth-config.model';

export function createAuthConfig(authConfigModel: AuthConfigModel, showDebugInformation: boolean): AuthConfig {
  const customQueryParams: { [key: string]: string } = {
    resource: authConfigModel.resource,
  };

  if (authConfigModel.acrValues) {
    customQueryParams['acr_values'] = authConfigModel.acrValues;
  }

  return {
    ...authConfigModel,
    showDebugInformation,

    //by default the resource parameter is not getting sent to the token endpoint
    resource: undefined,
    customQueryParams: customQueryParams,
    sessionChecksEnabled: true, //TODO: 42673 IAM: Frontend logout ohne Session https://dev.azure.com/techgroup/Maison%20du%20Software/_workitems/edit/42673
  };
}
